// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"CompanyInput_cardTitle__2KtEk","addBtn":"CompanyInput_addBtn__2H2IA","closeBtn":"CompanyInput_closeBtn__1garE","checkBox":"CompanyInput_checkBox__1JgBj"};